import $ from 'jquery';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');
	const $wholeBody = $('html, body, main#content');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const $menu = $('.menu');
	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
				$wholeBody.css('overflow', 'hidden');
				$wholeBody.css('height', '100vh');
				$menu.addClass('is-open');

				setTimeout(()=>{
					$menu.addClass('is-opened');
				}, 100);
			} else {
				$menu.removeClass('is-opened');
				$wholeBody.css('overflow', '');
				$wholeBody.css('height', '');

				setTimeout(()=>{
					$menu.removeClass('is-open');
				}, 300);

			}
		});
	}

	$(function(){
		let headings = $('.heading.-hidden');
		setTimeout(()=>{
			headings.slideDown(700);
		}, 200);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js